@if (menuParams && (menuOptions || menuGroups)) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="menuParams">
          <div class="control-div">
            <input #imageRef [formControlName]="'imageRef'" hidden>
            <select-media [image]="imageRef.value" [imageOnly]="false" [menuHeader]="true" (setImageRef)="setImage($event, menuParams)">
            </select-media>
          </div>
          <div class="control-div">
            <label class="control-label">Channel Display Type (Default)</label>
            <app-cms class="popover" [type]="'nodeBuild'" [field]="'displayType'"></app-cms>
            <display-type-btn  activeForm [activeForm]="menuParams" (change)="displayChange($event)" [data]="displayTypeModalData" [optionLength]="optionCount"></display-type-btn>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Menu Header </label>
              <label class="control-optional">Optional</label>
            </div>
            <input class="control-input" activeForm [activeForm]="menuParams" id="menuHeader" [formControlName]="'menuHeader'" placeholder="Name the menu header"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Sub Header </label>
              <label class="control-optional">Optional</label>
            </div>
            <input class="control-input" activeForm [activeForm]="menuParams" id="groupTitle" [formControlName]="'groupTitle'" placeholder="Add a subheader"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Body Text </label>
              <label class="control-required">Required</label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'bodyText', myForm: menuParams}">
            </ng-container>
            <textarea class="control-textArea" activeForm [activeForm]="menuParams" id="bodyText" [formControlName]="'bodyText'"
            placeholder="Enter a body text"></textarea>
          </div>
          <div class="control-div">
            <label class="control-label"> Variable Name </label>
            <app-cms class="popover" [type]="'nodeBuild'" [field]="'varName'"></app-cms>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'varName', myForm: menuParams}">
            </ng-container>
            <input class="control-input" activeForm [activeForm]="menuParams" id="varName" [formControlName]="'varName'" placeholder="Enter name for variable"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Option Separator </label>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'optionSeperator'"></app-cms>
              <label class="control-optional">Optional</label>
            </div>
            <mat-select [formControlName]="'optionSeperator'" class="control-dropdown" hideSingleSelectionIndicator>
              <div class="customSeparator_content">
                <input #inputSeparator  activeForm [activeForm]="menuParams" id="optionSeperator"  class="customSeparator_input" type="text"
                  placeholder="Add custom separator" (keydown.space)="$event.stopPropagation()"
                                   (keydown.enter)="addSeparator($event, inputSeparator.value);
                                   inputSeparator.value = ''"/>
                            <button class="customSeparator_btn" (click)=" addSeparator($event, inputSeparator.value);
                                     inputSeparator.value = ''">
                  </button>
                </div>
                @for (option of optionSeperatorList; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                }
              </mat-select>
            </div>
            <div class="control-div toggle-field">
              <div class="label-left-block">
                <label class="control-label"> Multiple Groups </label>
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'multipleGroups'"></app-cms>
              </div>
              <div class="toggle-btn">
                <mat-slide-toggle [color]="'primary'" class="control-toggle"
                  [formControlName]="'multipleGroups'" (change)="addOptionsToTheGroups($event)">
                </mat-slide-toggle>
              </div>
            </div>
            @if (!menuParams.value.multipleGroups) {
              <div class="control-div toggle-field">
                <div class="label-left-block">
                  <label class="control-label"> Multiple Selection </label>
                  <app-cms class="popover" [type]="'nodeBuild'" [field]="'multipleSelection'"></app-cms>
                </div>
                <div class="toggle-btn">
                  <mat-slide-toggle [color]="'primary'" class="control-toggle"
                    [formControlName]="'multipleSelection'">
                  </mat-slide-toggle>
                </div>
              </div>
            }
          </ng-container>
        </ng-container>
      </clickatell-expansion-panel>
      @if (!menuParams.value.multipleGroups) {
        <clickatell-expansion-panel>
          <ng-container header>
            <div class="hh">
              <mat-panel-title>
                Options
              </mat-panel-title>
            </div>
          </ng-container>
          <ng-container body>
            <ng-container *ngTemplateOutlet="logic; context: { index: 0, optionsList: menuOptions.controls, displayType: channelDisplayType, groupIndex: 0 }" ></ng-container>
            <div class="control-label-add-btn" (click)="addOption(menuOptions.controls.items)">
              <span class="control-label-add-btn-icon">
                <img class="action-img" src='./assets/svg/addIcon.svg'/>
              </span>
              <span class="control-label-add-btn-label">
                Add New Option
              </span>
            </div>
          </ng-container>
        </clickatell-expansion-panel>
      }
      @if (menuParams.value.multipleGroups) {
        <clickatell-expansion-panel>
          <ng-container header>
            <div class="hh">
              <mat-panel-title>
                Groups
              </mat-panel-title>
            </div>
          </ng-container>
          <ng-container body>
            <div class="add-new-item-block">
              <div class="collapse-expand-btn" (click)="collapseExpandGroups()"
                [matTooltip]="collapseExpandGroupsTooltip" matTooltipHideDelay="200" matTooltipClass="left-tooltip">
                {{ collapseExpandGroupsState === 'open' ? 'Collapse' : 'Expand' }} All Groups
              </div>
            </div>
            <ng-container *ngTemplateOutlet="group; context: { displayType: channelDisplayType }"></ng-container>
            <div class="control-label-add-btn add-group-btn" (click)="addGroup()">
              <span class="control-label-add-btn-icon">
                <img class="action-img" src='./assets/svg/addIcon.svg'/>
              </span>
              <span class="control-label-add-btn-label">
                Add New Group
              </span>
            </div>
          </ng-container>
        </clickatell-expansion-panel>
      }
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <div class="groups-data-container">
            <div class="control-div logic">
              <div class="control-label-container-set">
                <div class="logic-title-container">
                  <img src='../../../../../../../../../assets/svg/redesign/Check_Mark_Filled.svg' alt='' class="logic-title-image" />
                  <label class="control-label-header"> Next </label>
                </div>
                <ng-container [formGroup]="menuParams">
                  <div class="control-div adjust">
                    <label class="control-label"> Point To </label>
                    <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                    @if (nodeFlowDetails) {
                      <next-selector
                        [canEditFlows]="canEdit.canEditFlows"
                        [selectorType]="'both'"
                        [flowSteps]="nodeFlowDetails.currentFlowSteps"
                        [flows]="nodeFlowDetails.flows"
                        [name]="'next'"
                        [form]="menuParams"
                        [stepId]="nodeFlowDetails.stepId">
                      </next-selector>
                    }
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="control-div logic">
              <div class="control-label-container-set">
                <div class="logic-title-container">
                  <img src='../../../../../../../../../assets/svg/redesign/Check_Mark_Filled.svg' alt='' class="logic-title-image" />
                  <label class="control-label-header"> Default </label>
                </div>
                <ng-container [formGroup]="menuParams">
                  <div class="control-div adjust">
                    <div class="control-label-container">
                      <label class="control-label"> Point To </label>
                      <label class="control-optional">Optional</label>
                      <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                    </div>
                    @if (nodeFlowDetails) {
                      <next-selector
                        [canEditFlows]="canEdit.canEditFlows"
                        [selectorType]="'both'"
                        [flowSteps]="nodeFlowDetails.currentFlowSteps"
                        [flows]="nodeFlowDetails.flows"
                        [name]="'default'"
                        [form]="menuParams"
                        [stepId]="nodeFlowDetails.stepId"
                        [isOptional]="true">
                      </next-selector>
                    }
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </clickatell-expansion-panel>
    </div>
  }


  <ng-template #logic let-displayType="displayType" let-optionsList="optionsList" let-index="index" let-groupIndex="groupIndex">
    @if (optionsList.items.length > 0) {
      <div class="add-new-item-block">
        <div class="collapse-expand-btn" (click)="collapseExpandLogic(index, LogicAccordion)"
          [matTooltip]="collapseExpandTooltip" matTooltipHideDelay="200" matTooltipClass="left-tooltip">
          {{ collapseExpandStates[index] === 'open' ? 'Collapse' : 'Expand' }} All Options
        </div>
      </div>
    }
    <div attr.id="group_{{index}}">
      <mat-accordion cdkDropList (cdkDropListDropped)="dropped($event, optionsList)" class="result-logic-list" [multi]="true" #LogicAccordion="matAccordion">
        <!-- optionslist enabled items block start -->
        @for (logicOption of optionsList.items.controls; track logicOption; let index = $index) {
          <div>
            <div class="custom-placeholder" *cdkDragPlaceholder></div>
            <div [formGroup]="logicOption" class="logic-group">
              <div *cdkDragPreview class="logic-result-header dragging">
                <div class="logic-result-header-title">
                  <div class="title-text" [ngClass]="{ 'has-title': optionText.value }">
                    <span class="options-count">{{optionsStartCount[groupIndex] + index + 1}}.</span> {{optionText.value}}</div>
                    <div class="title-btns-block">
                      <div class="move-btn"></div>
                      <div class="remove-btn">
                      </div>
                    </div>
                  </div>
                </div>
                <mat-expansion-panel [expanded]="true" cdkDrag>
                  <mat-expansion-panel-header class="logic-result-header"
                                [ngClass]="{
                                    'warning': warningCondition && optionCount > displayType && (optionsStartCount[groupIndex] + index + 1 > displayType)
                                }">
                    <div class="tooltip" [matTooltip]="toolTipText" [matTooltipPosition]="'above'"></div>
                    <div class="logic-result-header-title">
                      <div class="title-text" [ngClass]="{ 'has-title': optionText.value}">
                        <span class="options-count">
                        {{optionsStartCount[groupIndex] + index + 1 + '.'}}</span>
                        {{ optionText.value ? optionText.value : (menuParams.value.multipleGroups ? '[Option Name]' : '[Option Title]')}}
                      </div>
                      <div class="title-btns-block options-title-container">
                        <div class="move-btn" cdkDragHandle></div>
                        <button mat-icon-button [matMenuTriggerFor]="menu" (click)="stopPropagationHandler($event)" class="options-menu">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" class="options-menu-container">
                          @for (group of menuGroups.value; track group; let moveToGroupIndex = $index) {
                            @if (moveToGroupIndex !== groupIndex && menuParams.value.multipleGroups) {
                              <button mat-menu-item class="option-menu-btn move-btn"
                                (click)="moveOptionToGroup(index, groupIndex, moveToGroupIndex)"
                                [disabled]="menuParams.value.multipleGroups ? menuGroups.value[groupIndex].items.length === 1 : menuOptions.value.items.length === 1">
                                <span>Move to {{ group.groupTitle }}</span>
                              </button>
                            }
                          }
                          <button mat-menu-item class="option-menu-btn enable-btn" [class]="{'disabled':menuParams.value.multipleGroups ? menuGroups.value[groupIndex].items.length === 1 : menuOptions.value.items.length === 1}">
                            <span class="enable-block">
                              <span>Enable</span>
                              <mat-slide-toggle [color]="'primary'" class="control-toggle"
                                (click)="stopPropagationHandler($event)"
                                (toggleChange)=" disableOption(index, groupIndex, menuParams.value.multipleGroups)"
                                [checked]="true"
                                [disabled]="menuParams.value.multipleGroups ? menuGroups.value[groupIndex].items.length === 1 : menuOptions.value.items.length === 1"
                                >
                              </mat-slide-toggle>
                            </span>
                          </button>
                          <button mat-menu-item class="option-menu-btn remove-btn"
                            (click)="removeOption(index, optionsList.items, false)"
                            [disabled]="menuParams.value.multipleGroups ? menuGroups.value[groupIndex].items.length === 1 : menuOptions.value.items.length === 1"
                            >
                            <span>Delete option</span>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  </mat-expansion-panel-header>
                  <div class="logic-result-container">
                    <div class="control-div">
                      <input #imageRef [formControlName]="'imageRef'" hidden>
                      <select-media [image]="imageRef.value" [imageOnly]="true"
                        (setImageRef)="setImage($event, logicOption)">
                      </select-media>
                    </div>
                    <div class="control-div">
                      <div class="control-label-container">
                        <label class="control-label"> Option {{optionsStartCount[groupIndex] + index + 1}} {{ menuParams.value.multipleGroups ? 'Name' : '' }}</label>
                      </div>
                      <ng-container
                        *ngTemplateOutlet="validators; context: { myControlName: 'text', myForm: logicOption}">
                      </ng-container>
                      <input #optionText class="control-input" activeForm [activeForm]="logicOption" id="text" [formControlName]="'text'"
                        placeholder="Add option {{ menuParams.value.multipleGroups ? 'name' : 'title' }}" [attr.disabled]="null"/>
                      </div>
                      <div class="control-div">
                        <div class="control-label-container">
                          <label class="control-label"> Value </label>
                          <label class="control-optional">Optional</label>
                        </div>
                        <input class="control-input" activeForm [activeForm]="logicOption" id="value" [formControlName]="'value'"
                          placeholder="Assign a value to the result" [attr.disabled]="null"/>
                        </div>
                        <div class="control-div">
                          <div class="control-label-container">
                            <label class="control-label"> Description </label>
                            <label class="control-optional">Optional</label>
                          </div>
                          <ng-container
                            *ngTemplateOutlet="validators; context: { myControlName: 'bodyText', myForm: logicOption}">
                          </ng-container>
                          <input class="control-input" activeForm [activeForm]="logicOption" id="bodyText" [formControlName]="'bodyText'"
                            placeholder="Add description / subtext" [attr.disabled]="null"/>
                            <clickatell-chip [name]="'keywords'" [field]="KEYWORD_FIELD" [form]="logicOption" [minLength]="null">
                            </clickatell-chip>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>
                  </div>
                }
                <!-- optionslist enabled items block end -->

                <!-- optionslist disabled items block start -->
                @for (logicOption of optionsList.disabledItems.controls; track logicOption; let index = $index) {
                  <div>
                    <div class="custom-placeholder" *cdkDragPlaceholder></div>
                    <div [formGroup]="logicOption" class="logic-group">
                      <div *cdkDragPreview class="logic-result-header dragging">
                        <div class="logic-result-header-title">
                          <div class="title-text" [ngClass]="{ 'has-title': optionText.value }">
                            <span class="options-count">{{optionsStartCount[groupIndex] + index + 1}}.</span> {{optionText.value}}</div>
                            <div class="title-btns-block">
                              <div class="move-btn"></div>
                              <div class="remove-btn">
                              </div>
                            </div>
                          </div>
                        </div>
                        <mat-expansion-panel [expanded]="true" cdkDrag>
                          <mat-expansion-panel-header class="logic-result-header disabled-option"
                                [ngClass]="{
                                    'warning': warningCondition && optionCount > displayType && (optionsStartCount[groupIndex] + index + 1 > displayType)
                                }">
                            <div class='tooltip' [matTooltip]="toolTipText" [matTooltipPosition]="'above'"></div>
                            <div class="logic-result-header-title">
                              <div class="title-text">
                                <span class="disabled-count"></span>
                                {{ optionText.value ? optionText.value : (menuParams.value.multipleGroups ? '[Option Name]' : '[Option Title]')}}
                              </div>
                              <div class="title-btns-block options-title-container">
                                <div class="move-btn" cdkDragHandle></div>
                                <button mat-icon-button [matMenuTriggerFor]="menu" (click)="stopPropagationHandler($event)" class="options-menu">
                                  <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu" class="options-menu-container">
                                  @for (group of menuGroups.value; track group; let moveToGroupIndex = $index) {
                                    @if (moveToGroupIndex !== groupIndex && menuParams.value.multipleGroups) {
                                      <button mat-menu-item class="option-menu-btn move-btn"
                                        (click)="moveDisabledOptionToGroup(index, groupIndex, moveToGroupIndex)"
                                        [disabled]="false">
                                        <span>Move to {{ group.groupTitle }}</span>
                                      </button>
                                    }
                                  }
                                  <button mat-menu-item class="option-menu-btn enable-btn">
                                    <span class="enable-block">
                                      <span>Enable</span>
                                      <mat-slide-toggle [color]="'primary'" class="control-toggle"
                                        (click)="stopPropagationHandler($event)"
                                        (toggleChange)=" enableOption(index, groupIndex, menuParams.value.multipleGroups)"
                                        [checked]="false"
                                        [disabled]="false"
                                        >
                                      </mat-slide-toggle>
                                    </span>
                                  </button>
                                  <button mat-menu-item class="option-menu-btn remove-btn"
                                    (click)="removeOption(index, optionsList.disabledItems, true)"
                                    [disabled]="false"
                                    >
                                    <span>Delete option</span>
                                  </button>
                                </mat-menu>
                              </div>
                            </div>
                          </mat-expansion-panel-header>
                          <div class="logic-result-container">
                            <div class="option-disabled-warn-block">
                              Option disabled.
                            </div>
                            <div class="control-div select-media-container">
                              <div class="select-media-block">
                                <div class="image-block"></div>
                                <div class="add-image-btn-block">
                                  + Add Image
                                </div>
                              </div>
                            </div>
                            <div class="control-div">
                              <label class="control-label"> Option {{optionsStartCount[groupIndex] + index + 1}} {{ menuParams.value.multipleGroups ? 'Name' : '' }}</label>
                              <ng-container
                                *ngTemplateOutlet="validators; context: { myControlName: 'text', myForm: logicOption}">
                              </ng-container>
                              <input #optionText class="control-input" activeForm [activeForm]="logicOption" id="text" [formControlName]="'text'"
                                placeholder="Add option {{ menuParams.value.multipleGroups ? 'name' : 'title' }}" [attr.disabled]="''"/>
                              </div>
                              <div class="control-div">
                                <div class="control-label-container">
                                  <label class="control-label"> Value </label>
                                  <label class="control-optional">Optional</label>
                                </div>
                                <input class="control-input" activeForm [activeForm]="logicOption" id="value" [formControlName]="'value'"
                                  placeholder="Assign a value to the result" [attr.disabled]="''"/>
                                </div>
                                <div class="control-div">
                                  <div class="control-label-container">
                                    <label class="control-label"> Description </label>
                                    <label class="control-optional">Optional</label>
                                  </div>
                                  <ng-container
                                    *ngTemplateOutlet="validators; context: { myControlName: 'bodyText', myForm: logicOption}">
                                  </ng-container>
                                  <input class="control-input" activeForm [activeForm]="logicOption" id="bodyText" [formControlName]="'bodyText'"
                                    placeholder="Add description / subtext" [attr.disabled]="''"/>
                                    <input class="control-input fake-input" placeholder="Add keyword(s)" [attr.disabled]="true"/>
                                  </div>
                                </div>
                              </mat-expansion-panel>
                            </div>
                          </div>
                        }
                        <!-- optionslist disabled items block end -->
                      </mat-accordion>
                    </div>
                  </ng-template>

                  <ng-template #group let-displayType="displayType">
                    <div>
                      <mat-accordion cdkDropList (cdkDropListDropped)="droppedGroup($event, menuGroups)" class="result-logic-list groups-list" [multi]="true" #GroupsAccordion="matAccordion">
                        @for (groupOption of menuGroups.controls; track groupOption; let index = $index) {
                          <div>
                            <div class="custom-placeholder" *cdkDragPlaceholder></div>
                            <div [formGroup]="groupOption" class="logic-group">
                              <div *cdkDragPreview class="logic-result-header dragging">
                                <div class="logic-result-header-title">
                                  <div class="title-text" [ngClass]="{ 'has-title': groupTitle.value }">{{ groupTitle.value ? groupTitle.value : '[Group Title]' }}</div>
                                  <div class="title-btns-block">
                                    <div class="move-btn"></div>
                                    <div class="remove-btn">
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <mat-expansion-panel [expanded]="true" cdkDrag>
                                <mat-expansion-panel-header class="logic-result-header">
                                  <div class="logic-result-header-title">
                                    <div class="title-text" [ngClass]="{ 'has-title': groupTitle.value }">{{ groupTitle.value ? groupTitle.value : '[Group Title]' }}</div>
                                    <div class="title-btns-block">
                                      <div class="move-btn" cdkDragHandle></div>
                                      <div class="remove-btn" (click)="removeGroup(index,  $event)">
                                      </div>
                                    </div>
                                  </div>
                                </mat-expansion-panel-header>
                                <div class="logic-result-container">
                                  <div class="control-div">
                                    <div class="control-label-container group-title-label-container">
                                      <label class="control-label"> Group {{ index + 1 }} Title </label>
                                    </div>
                                    <ng-container
                                      *ngTemplateOutlet="validators; context: { myControlName: 'groupTitle', myForm: groupOption}">
                                    </ng-container>
                                    <input #groupTitle class="control-input" [formControlName]="'groupTitle'" placeholder="Add group title"/>
                                  </div>
                                  <div class="control-div toggle-field">
                                    <label class="control-label"> Multiple Selection </label>
                                    <div class="toggle-btn">
                                      <mat-slide-toggle [color]="'primary'" class="control-toggle"
                                        [formControlName]="'multipleSelection'">
                                      </mat-slide-toggle>
                                    </div>
                                  </div>
                                  <div class="group-options-container">
                                    <div class="control-div group-options-block">
                                      <ng-container *ngTemplateOutlet="logic; context: { index: index, optionsList: groupOption.controls, groupIndex: index, enabled: true, displayType: displayType }" ></ng-container>
                                      <div class="control-label-add-btn" (click)="addOption(groupOption.controls.items)">
                                        <span class="control-label-add-btn-icon">
                                          <img class="action-img" src='./assets/svg/addIcon.svg'/>
                                        </span>
                                        <span class="control-label-add-btn-label">
                                          Add New Option
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </mat-expansion-panel>
                            </div>
                          </div>
                        }
                      </mat-accordion>
                    </div>
                  </ng-template>


                  <ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
                    @if (myForm.controls[myControlName]; as control) {
                      @if (control.invalid && (control.dirty || control.touched)) {
                        <div class="validationField">
                          @for (error of control.errors | keyvalue; track error) {
                            <div>
                              <span class="fa fa-exclamation-circle"></span>
                              <span [id]="'validationField-' + myControlName">
                                {{error.value}}
                              </span>
                            </div>
                          }
                        </div>
                      }
                    }
                  </ng-template>


                  <ng-template #optionWarning>

                    @for (channel of allChannelConfig; track channel) {
                      @if (supportedChannels.includes(channel['channel-id'])) {
                        <div>
                          @if (displayIndex[channel['channel-id']][this.menuParams.get('displayType').value[channel['channel-id']]]; as display) {
                            <div>
                              @if (display.max < optionCount && display.max > 0) {
                                <div class="banner-container">
                                  <div class="banner-block">
                                    <div class="icon"></div>
                                    <div class="content">
                                      You have {{ optionCount }} logic options. <span
                                    style="text-transform:capitalize;">{{ display.name }}</span> menus can only
                                    support up to {{ display.max }}. Additional options will not be displayed.
                                    <a class="banner-link" target="_blank" href="https://clickatell.gitbook.io/flow/">
                                      Read more.
                                    </a>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  }
                </ng-template>

                <ng-template #numberedListWarning let-displayType=displayType>
                  @if (displayType.dirty && displayType.value['8'] !== 'NUMBER') {
                    <div class="banner-container">
                      <div class="banner-block">
                        <div class="icon"></div>
                        <div class="content">
                          Only "Numbered List" supports formatting in the Menu Header. Please refrain from using
                          formatting in the Menu Headers and Sub Headers of other display types.
                          <a class="banner-link" target="_blank" href="https://clickatell.gitbook.io/flow/">
                            Read more.
                          </a>
                        </div>
                      </div>
                    </div>
                  }
                </ng-template>
